//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { date } from 'quasar'
import TimePickerValueSelector from './TimePickerValueSelector.vue'

export default {
  name: 'TimePicker',
  components: {
    TimePickerValueSelector
  },
  props: {
    value: {
      type: String,
      default: null
    },
    format: {
      type: String,
      default: null
    },
    options: {
      type: Function,
      default: () => true
    },
    minuteOptions: {
      type: Array,
      default: () => undefined
    },
    withSeconds: {
      type: Boolean,
      default: false
    },
    nowBtn: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      hours: null,
      minutes: null,
      seconds: null
    }
  },
  computed: {
    complexValue: function () {
      return {
        hours: this.hours ? this.hours.value : null,
        minutes: this.minutes ? this.minutes.value : null,
        seconds: this.seconds ? this.seconds.value : null
      }
    },
    localTextValue: {
      get: function () {
        return this.value
      },
      set: function (value) {
        return this.$emit('input', value)
      }
    },
    localMillisValue: function () {
      return this.parseMillis(this.localTextValue)
    }
  },
  watch: {
    localTextValue: {
      handler: function (value) {
        if (this.hours) { // проверка инициализации
          this.updateSelectedItems(value)
          this.$nextTick(() => {
            this.updateActiveItems()
          })
        }
      },
      immediate: true
    }
  },
  created: function () {
    const vm = this
    const optionsFn = this.options
    this.hours = this.generateTimePartConfig({
      maxValue: 24,
      type: 'hours',
      formatPart: 'HH',
      applyItemToDateFn: function (date) {
        if (this.selectedItem) {
          date.setHours(this.selectedItem.value)
        }
      },
      optionsFn: !optionsFn ? null : function (hr, fullValueMillis) {
        return optionsFn(hr, vm.complexValue.minutes, vm.complexValue.second, fullValueMillis)
      }
    })
    this.minutes = this.generateTimePartConfig({
      maxValue: 60,
      type: 'minutes',
      formatPart: 'mm',
      applyItemToDateFn: function (date) {
        if (this.selectedItem) {
          date.setMinutes(this.selectedItem.value)
        }
      },
      options: this.minuteOptions,
      optionsFn: !optionsFn ? null : function (min, fullValueMillis) {
        return optionsFn(vm.complexValue.hours, min, vm.complexValue.seconds, fullValueMillis)
      }
    })

    this.seconds = this.generateTimePartConfig({
      maxValue: 60,
      type: 'seconds',
      formatPart: 'ss',
      applyItemToDateFn: function (date) {
        if (vm.withSeconds) {
          if (this.selectedItem) {
            date.setSeconds(this.selectedItem.value)
          }
        } else {
          date.setSeconds(0)
        }
        date.setMilliseconds(0)
      },
      optionsFn: !optionsFn ? null : function (sec, fullValueMillis) {
        return optionsFn(vm.complexValue.hours, vm.complexValue.minutes, sec, fullValueMillis)
      }
    })
  },
  mounted: function () {
    this.updateSelectedItems(this.localTextValue)
  },
  methods: {
    formatMillis: function (millis) {
      if (millis) {
        return date.formatDate(millis, this.format)
      }
      return null
    },
    parseDate (value) {
      return date.extractDate(value, this.format)
    },
    parseMillis (value) {
      return this.parseDate(value).getTime()
    },

    generateTimePartConfig: function ({ maxValue, type, formatPart, applyItemToDateFn, options, optionsFn }) {
      const vm = this
      return {
        type,
        formatPart,
        selectedItem: null,
        selectedItemText: null,
        items: this.generateValueItems(maxValue, type, options, optionsFn),
        updateSelectedItem: function (value, format) {
          if (value) {
            const formatPart = this.formatPart
            const formatPartIndex = format.indexOf(formatPart)
            if (formatPartIndex != -1) {
              const valuePart = value.substring(formatPartIndex, formatPartIndex + formatPart.length)
              const selectedItem = this.items.find(item => item.text === valuePart)
              this.selectedItem = selectedItem
              this.selectedItemText = this.selectedItem ? this.selectedItem.text : null
            }
          } else {
            this.selectedItem = null
            this.selectedItemText = null
          }
        },
        updateActiveItems: function () {
          for (const item of this.items) {
            item.active = vm.isOptionActive(item.value, options, optionsFn)
          }
        },
        applyToDate: applyItemToDateFn
      }
    },
    generateValueItems: function (maxValue, type, options, optionsFn) {
      const items = []
      for (let value = 0; value < maxValue; value++) {
        items.push({
          type,
          value,
          text: value < 10 ? '0' + value : '' + value,
          active: this.isOptionActive(value, options, optionsFn)
        })
      }
      return items
    },
    isOptionActive: function (value, options, optionsFn) {
      if (options) {
        return options.includes(value)
      } else if (optionsFn) {
        return optionsFn(value, this.localMillisValue)
      }
      return true
    },
    getTypeConfig: function (type) {
      return this[type]
    },
    onSelect: function (item) {
      const typeConfig = this.getTypeConfig(item.type)
      if (typeConfig) {
        typeConfig.selectedItem = item

        if (this.localTextValue) {
          const date = this.parseDate(this.localTextValue)
          typeConfig.applyToDate(date)
          this.localTextValue = this.formatMillis(date)

          // const formatPart = typeConfig.formatPart
          // const formatIndex = this.format.indexOf(formatPart)
          // if (formatIndex != -1) {
          //   this.localTextValue = this.localTextValue.substring(0, formatIndex) + item.text + this.localTextValue.substring(formatIndex + item.text.length)
          // }
        } else if (this.hours.selectedItem && this.minutes.selectedItem && (this.seconds.selectedItem || !this.withSeconds)) {
          const date = new Date()
          this.hours.applyToDate(date)
          this.minutes.applyToDate(date)
          this.seconds.applyToDate(date)

          this.localTextValue = this.formatMillis(date)
        }
      }
    },
    updateSelectedItems: function (value) {
      this.hours.updateSelectedItem(value, this.format)
      this.minutes.updateSelectedItem(value, this.format)
      this.seconds.updateSelectedItem(value, this.format)
    },
    updateActiveItems: function () {
      this.hours.updateActiveItems()
      this.minutes.updateActiveItems()
      this.seconds.updateActiveItems()
    },

    onSelectorKeyDown: function (event) {
      if (event.code === 'ArrowLeft' || event.code === 'ArrowRight') {
        const selectorEl = event.currentTarget.parentElement.parentElement // time-picker__value-selector
        const timePickerInnerEl = selectorEl.parentElement // time-picker__inner
        let selectorIndex = null
        for (let i = 0; i < timePickerInnerEl.children.length; i++) {
          if (timePickerInnerEl.children[i] === selectorEl) {
            selectorIndex = i
            break
          }
        }

        const nextIndex = event.code === 'ArrowLeft' ? selectorIndex - 1 : selectorIndex + 1
        if (nextIndex >= 0 && nextIndex < timePickerInnerEl.children.length) {
          const nextSelectorEl = timePickerInnerEl.children[nextIndex]
          const nextSelector = nextSelectorEl.__vue__
          nextSelector.focusSelectedItem()
        }
      }
    },

    onSetCurrentTime: function () {
      this.localTextValue = this.formatMillis(new Date().getTime())
    }
  }
}

